export default __webpack_public_path__ + "static/media/banners_14.1ad7b48c.png";